import React from 'react';
import { Switch } from 'react-router-dom';

import Route from './Route';

import Home from '~/pages/Home';
import DentistaBarueri from '~/pages/DentistaBarueri';
// import Blog from '~/pages/Blog';
import Notice from '~/pages/OldBlog/Notice';
import Contact from '~/pages/Contact';
import Welcome from '~/pages/Welcome';
import Links from '~/pages/Links';
import Tv from '~/pages/Tv';
import CoiDay from '~/pages/CoiDay';
import CoiPrimeDay from '~/pages/CoiPrimeDay';
import Implants from '~/pages/Implants';
import DentalAesthetics from '~/pages/DentalAesthetics';
import Login from '~/pages/Admin/Login';
import ManageBlog from '~/pages/Admin/ManageBlog';
import Blog from '~/pages/Blog';
import Dashboard from '~/pages/Dashboard';

const routes: React.FC = () => {
  return (
    <Switch>
      {/* <Route path={`${process.env.PUBLIC_URL}/`} exact component={Links} /> */}
      <Route
        path={`${process.env.PUBLIC_URL}/`}
        exact
        component={DentistaBarueri}
      />
      {/* <Route
        path={`${process.env.PUBLIC_URL}/dentistabarueri`}
        exact
        component={Home}
      /> */}
      <Route
        path={`${process.env.PUBLIC_URL}/dentistabarueri`}
        exact
        component={DentistaBarueri}
      />
      {/* <Route
        path={`${process.env.PUBLIC_URL}/baruerialphaville`}
        exact
        component={Home}
      /> */}
      <Route
        path={`${process.env.PUBLIC_URL}/baruericentro`}
        exact
        component={Home}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/rede-social`}
        exact
        component={Home}
      />
      {/* <Route path={`${process.env.PUBLIC_URL}/blog`} exact component={Blog} /> */}
      <Route
        path={`${process.env.PUBLIC_URL}/blog/:slug`}
        exact
        component={Notice}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/contato`}
        exact
        component={Contact}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/bem-vindos`}
        exact
        component={Welcome}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/implantes`}
        exact
        component={Implants}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/estetica`}
        exact
        component={DentalAesthetics}
      />
      <Route path={`${process.env.PUBLIC_URL}/links`} exact component={Links} />
      <Route path={`${process.env.PUBLIC_URL}/tv`} exact component={Tv} />
      <Route
        path={`${process.env.PUBLIC_URL}/coi-day`}
        exact
        component={CoiDay}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/coi-prime-day`}
        exact
        component={CoiPrimeDay}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/admin/login`}
        exact
        component={Login}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/admin/blog`}
        isPrivate
        component={ManageBlog}
      />
      <Route path={`${process.env.PUBLIC_URL}/blog`} exact component={Blog} />
      <Route path="/dashboard" isPrivate component={Dashboard} />
    </Switch>
  );
};

export default routes;
